import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import axiosConfig from "../../axiosConfig";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Typography } from '@material-ui/core';
import temperatureLogo from "../../assets/images/thermometer.png";
import pressureLogo from "../../assets/images/blood-pressure-control-tool.png";
import slipLogo from "../../assets/images/falling-man-.png";
import sosLogo from "../../assets/images/sos.png";
import heartbeatLogo from "../../assets/images/heartbeat.png";
import spo2Logo from "../../assets/images/spo2.png";
import fenceLogo from "../../assets/images/fence.jpg";
import removeDeviceLogo from "../../assets/images/remove_icon.png";
import batteryLogo from "../../assets/images/battery-full.png";
import { Card, CardHeader, CardBody } from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";
import * as alarmTypes from "../../shared/language.json";

import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import Slider from "@material-ui/core/Slider";
import Button from "@material-ui/core/Button";
import ValueLabel from "@material-ui/core/Slider/ValueLabel";

import { swalSubmit } from "../../shared/swalSubmit";
import Loading from "../Loading/loading";

import "../Forms/Forms.css";

const useStyles = makeStyles({
  FormHelperText: {
    marginTop: 20
  },
  gridSlider :{
    marginRight:15
  }
});

export default function SmartBandValues(props) {
  const [state, setState] = useState({
    diastolicPressure: null,
    systolicPressure: null,
    temperature: null,
    heartbeat: null,
    spO2: null,

    editDiastolicPressure: false,
    editSystolicPressure: false,
    editTemperature: false,
    editHeartbeat: false,
    editSpO2: false,
    editBattery: false,
    diastolicValue: [],
    diastolicValue2: [],
    diastolicValue3: [],
    diastolicValue4: [],
    diastolicValue5: [],
    diastolicValue6: [],
    systolicValue: [],
    systolicValue2: [],
    systolicValue3: [],
    systolicValue4: [],
    systolicValue5: [],
    systolicValue6: [],
    temperatureValue: [],
    temperatureValue2: [],
    temperatureValue3: [],
    temperatureValue4: [],
    temperatureValue5: [],
    temperatureValue6: [],
    heartbeatValue: [],
    heartbeatValue2: [],
    heartbeatValue3: [],
    heartbeatValue4: [],
    heartbeatValue5: [],
    heartbeatValue6: [],
    spO2Value: [],
    spO2Value2: [],
    spO2Value3: [],
    spO2Value4: [],
    spO2Value5: [],
    spO2Value6: [],
    fenceValue: []
  });
  const [disableDiastolicPressureByEdit, setDisableDiastolicPressureByEdit] = useState(null);
  const [disableSystolicPressureByEdit, setDisableSystolicPressureByEdit] = useState(null);
  const [disableTemperatureByEdit, setDisableTemperatureByEdit] = useState(null);
  const [disableHeartBeatByEdit, setDisableHeartBeatByEdit] = useState(null);
  const [disableSpo2ByEdit, setdisableSpo2ByEdit] = useState(null);

 useEffect(() => {
    let newStateDiastolicPressure = state.diastolicPressure === true ? true : false;
    setDisableDiastolicPressureByEdit(!newStateDiastolicPressure)
    setState(prevState => ({ ...prevState, editDiastolicPressure: newStateDiastolicPressure ? prevState.editDiastolicPressure : false }))
  }, [state.diastolicPressure])

  useEffect(() => {
    let newStateSystolicPressure = state.systolicPressure === true ? true : false;
    setDisableSystolicPressureByEdit(!newStateSystolicPressure)
    setState(prevState => ({ ...prevState, editSystolicPressure: newStateSystolicPressure ? prevState.editSystolicPressure : false }))
  }, [state.systolicPressure])

  useEffect(() => {
    let newStateTemperature = !!state.temperature;
    setState(prevState => ({ ...prevState, editTemperature: newStateTemperature ? prevState.editTemperature : false }))
  }, [state.temperature])

  useEffect(() => {
    let newStateHeartbeat = !!state.heartbeat;
    setState(prevState => ({ ...prevState, editHeartbeat: newStateHeartbeat ? prevState.editHeartbeat : false }))
  }, [state.heartbeat])

  useEffect(() => {
    let newStateSpo2 = !!state.spO2;
    setState(prevState => ({ ...prevState, editSpO2: newStateSpo2 ? prevState.editSpO2 : false }))
  }, [state.spO2])


  const classes = useStyles();
  let history = useHistory();

  const [loading, setLoading] = useState(true);
  const [isUserNotified, setIsUserNotified] = useState(true);
  const [enableEditValues, setEnableEditValues] = useState(false);
  const [isInitialView, setIsInitialView] = useState(false);
  const [deviceId, setDeviceId] = useState();

  const StyledValueLabel = withStyles({
    offset: {
      top: -28,
      left: props =>
        props.index === 0 ? "calc(-50% + -20px)" : "calc(-50% + 12px)"
    },
    circle: {
      transform: props => (props.index === 0 ? "rotate(-90deg)" : "rotate(0deg)")
    },
    label: {
      transform: props => (props.index === 0 ? "rotate(90deg)" : "rotate(0deg)")
    }
  })(ValueLabel);

  const MySlider = withStyles({
    root: {
      color: "#3880ff",
      height: 2,
      padding: "15px 0"
    },

    track: {
      height: 4
    },
    thumb: {
      background: "transparent",
      "&:focus,&:hover,&$active": {
        boxShadow: "inherit"
      }
    },
    rail: {
      height: 4,
      opacity: 0.5,
      backgroundColor: "#bfbfbf"
    },
    mark: {
      backgroundColor: "#bfbfbf",
      height: 8,
      width: 1,
      marginTop: -2
    }
  })(Slider);

  const diastolicMarks = [
    {
      value: 4.5,
      label: "4.5mmHg",
    },
    {
      value: 14,
      label: "14mmHg",
    },
  ];
  const systolicMarks = [
    {
      value: 7,
      label: "7mmHg",
    },
    {
      value: 22,
      label: "22mmHg",
    },
  ];

  const temperatureMarks = [
    {
      value: 25,
      label: "25°C",
    },
    {
      value: 41,
      label: "41°C",
    },
  ];

  const heartbeatMarks = [
    {
      value: 50,
      label: "50bpm",
    },
    {
      value: 200,
      label: "200bpm",
    },
  ];

  const spO2Marks = [
    {
      value: 89,
      label: "89%",
    },
    {
      value: 100,
      label: "100%",
    },
  ];

  const setDefaultsValues = (values, desc, sev, rangedesc) => {
    let result;
    values.forEach((value) => {
      if (value.description === desc) {
        value.ranges.forEach((range) => {
          if (range.severity === sev && range.range === rangedesc) {
            return (result = [range.left, range.right]);
          }
        });
      }
    });
    return result;
  };
  useEffect(() => {
    if (props.location.pathname === "/initial-config") {
      setIsInitialView(true);
    }
  }, [setIsInitialView, props.location.pathname]);

  useEffect(() => {
    if (isUserNotified && props.location.pathname !== "/initial-config") {
      Swal.fire({
        title: "ΑΡΧΙΚΕΣ ΡΥΘΜΙΣΕΙΣ",
        html:
          "<div>" +
          "<h2>Για την ολοκλήρωση της καταχώρησής σας θα πρέπει " +
          "να επιβεβαιώσετε ή να αλλάξετε, " +
          " (εάν απαιτείται) τις Αρχικές Ρυθμίσεις της συσκευής" +
          "</div>",
        icon: "info",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Συνέχεια",
        showLoaderOnConfirm: true,
        closeOnClickOutside: false,
      }).then(() => {
        setIsUserNotified(false);
      });
    }
  }, [
    isUserNotified,
    setIsUserNotified,
    props.location.endUserData,
    props.location.pathname,
  ]);

  useEffect(() => {
    if (isInitialView || props.location.locationPath === "AddEndUser") {
      axiosConfig
        .get(`/DeviceValues/GetDefaultDeviceValues/`)
        .then((res) => {
          setState({
            ...state,
            diastolicPressure: res.data[4].isActive,
            diastolicValue: setDefaultsValues(
              res.data,
              "diastolic",
              "High",
              "MaxRange"
            ),
            diastolicValue2: setDefaultsValues(
              res.data,
              "diastolic",
              "High",
              "MinRange"
            ),
            diastolicValue3: setDefaultsValues(
              res.data,
              "diastolic",
              "Middle",
              "MaxRange"
            ),
            diastolicValue4: setDefaultsValues(
              res.data,
              "diastolic",
              "Middle",
              "MinRange"
            ),
            diastolicValue5: setDefaultsValues(
              res.data,
              "diastolic",
              "Low",
              "MaxRange"
            ),
            diastolicValue6: setDefaultsValues(
              res.data,
              "diastolic",
              "Low",
              "MinRange"
            ),
            systolicPressure: res.data[3].isActive,
            systolicValue: setDefaultsValues(
              res.data,
              "systolic",
              "High",
              "MinRange"
            ),
            systolicValue2: setDefaultsValues(
              res.data,
              "systolic",
              "High",
              "MaxRange"
            ),
            systolicValue3: setDefaultsValues(
              res.data,
              "systolic",
              "Middle",
              "MinRange"
            ),
            systolicValue4: setDefaultsValues(
              res.data,
              "systolic",
              "Middle",
              "MaxRange"
            ),
            systolicValue5: setDefaultsValues(
              res.data,
              "systolic",
              "Low",
              "MaxRange"
            ),
            systolicValue6: setDefaultsValues(
              res.data,
              "systolic",
              "Low",
              "MinRange"
            ),
            temperature: res.data[2].isActive,
            temperatureValue: setDefaultsValues(
              res.data,
              "temperature",
              "High",
              "MinRange"
            ),
            temperatureValue2: setDefaultsValues(
              res.data,
              "temperature",
              "High",
              "MaxRange"
            ),
            temperatureValue3: setDefaultsValues(
              res.data,
              "temperature",
              "Middle",
              "MinRange"
            ),
            temperatureValue4: setDefaultsValues(
              res.data,
              "temperature",
              "Middle",
              "MaxRange"
            ),
            temperatureValue5: setDefaultsValues(
              res.data,
              "temperature",
              "Low",
              "MaxRange"
            ),
            temperatureValue6: setDefaultsValues(
              res.data,
              "temperature",
              "Low",
              "MinRange"
            ),
            heartbeat: res.data[1].isActive,
            heartbeatValue: setDefaultsValues(
              res.data,
              "heart_rate",
              "High",
              "MaxRange"
            ),
            heartbeatValue2: setDefaultsValues(
              res.data,
              "heart_rate",
              "High",
              "MinRange"
            ),
            heartbeatValue3: setDefaultsValues(
              res.data,
              "heart_rate",
              "Middle",
              "MaxRange"
            ),
            heartbeatValue4: setDefaultsValues(
              res.data,
              "heart_rate",
              "Middle",
              "MinRange"
            ),
            heartbeatValue5: setDefaultsValues(
              res.data,
              "heart_rate",
              "Low",
              "MaxRange"
            ),
            heartbeatValue6: setDefaultsValues(
              res.data,
              "heart_rate",
              "Low",
              "MinRange"
            ),
            spO2: res.data[0].isActive,
            spO2Value: setDefaultsValues(
              res.data,
              "oxygen",
              "High",
              "MinRange"
            ),
            spO2Value2: setDefaultsValues(
              res.data,
              "oxygen",
              "High",
              "MaxRange"
            ),
            spO2Value3: setDefaultsValues(
              res.data,
              "oxygen",
              "Middle",
              "MinRange"
            ),
            spO2Value4: setDefaultsValues(
              res.data,
              "oxygen",
              "Middle",
              "MaxRange"
            ),
            spO2Value5: setDefaultsValues(
              res.data,
              "oxygen",
              "Low",
              "MaxRange"
            ),
            spO2Value6: setDefaultsValues(
              res.data,
              "oxygen",
              "Low",
              "MinRange"
            ),
            editDiastolicPressure: false,
            editSystolicPressure: false,
            editTemperature: false,
            editHeartbeat: false,
            editSpO2: false,           
          });
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (
      props.location.locationPath === "EditEndUser" ||
      props.location.locationPath === "EndUsers"
    ) {
      setDeviceId(props.location.selected);
      axiosConfig.get(`/DeviceValues/GetDeviceValues/${props.location.selected}`).then((res) => {
        setState({
          ...state,
          diastolicPressure: res.data[4].isActive,
          diastolicValue: setDefaultsValues(
            res.data,
            "diastolic",
            "High",
            "MaxRange"
          ),
          diastolicValue2: setDefaultsValues(
            res.data,
            "diastolic",
            "High",
            "MinRange"
          ),
          diastolicValue3: setDefaultsValues(
            res.data,
            "diastolic",
            "Middle",
            "MaxRange"
          ),
          diastolicValue4: setDefaultsValues(
            res.data,
            "diastolic",
            "Middle",
            "MinRange"
          ),
          diastolicValue5: setDefaultsValues(
            res.data,
            "diastolic",
            "Low",
            "MaxRange"
          ),
          diastolicValue6: setDefaultsValues(
            res.data,
            "diastolic",
            "Low",
            "MinRange"
          ),
          systolicValue: setDefaultsValues(
            res.data,
            "systolic",
            "High",
            "MinRange"
          ),
          systolicPressure: res.data[3].isActive,
          systolicValue2: setDefaultsValues(
            res.data,
            "systolic",
            "High",
            "MaxRange"
          ),
          systolicValue3: setDefaultsValues(
            res.data,
            "systolic",
            "Middle",
            "MinRange"
          ),
          systolicValue4: setDefaultsValues(
            res.data,
            "systolic",
            "Middle",
            "MaxRange"
          ),
          systolicValue5: setDefaultsValues(
            res.data,
            "systolic",
            "Low",
            "MaxRange"
          ),
          systolicValue6: setDefaultsValues(
            res.data,
            "systolic",
            "Low",
            "MinRange"
          ),
          temperature: res.data[2].isActive,
          temperatureValue: setDefaultsValues(
            res.data,
            "temperature",
            "High",
            "MinRange"
          ),
          temperatureValue2: setDefaultsValues(
            res.data,
            "temperature",
            "High",
            "MaxRange"
          ),
          temperatureValue3: setDefaultsValues(
            res.data,
            "temperature",
            "Middle",
            "MinRange"
          ),
          temperatureValue4: setDefaultsValues(
            res.data,
            "temperature",
            "Middle",
            "MaxRange"
          ),
          temperatureValue5: setDefaultsValues(
            res.data,
            "temperature",
            "Low",
            "MaxRange"
          ),
          temperatureValue6: setDefaultsValues(
            res.data,
            "temperature",
            "Low",
            "MinRange"
          ),
          heartbeat: res.data[1].isActive,
          heartbeatValue: setDefaultsValues(
            res.data,
            "heart_rate",
            "High",
            "MaxRange"
          ),
          heartbeatValue2: setDefaultsValues(
            res.data,
            "heart_rate",
            "High",
            "MinRange"
          ),
          heartbeatValue3: setDefaultsValues(
            res.data,
            "heart_rate",
            "Middle",
            "MaxRange"
          ),
          heartbeatValue4: setDefaultsValues(
            res.data,
            "heart_rate",
            "Middle",
            "MinRange"
          ),
          heartbeatValue5: setDefaultsValues(
            res.data,
            "heart_rate",
            "Low",
            "MaxRange"
          ),
          heartbeatValue6: setDefaultsValues(
            res.data,
            "heart_rate",
            "Low",
            "MinRange"
          ),
          spO2: res.data[0].isActive,
          spO2Value: setDefaultsValues(
            res.data,
            "oxygen",
            "High",
            "MinRange"
          ),
          spO2Value2: setDefaultsValues(
            res.data,
            "oxygen",
            "High",
            "MaxRange"
          ),
          spO2Value3: setDefaultsValues(
            res.data,
            "oxygen",
            "Middle",
            "MinRange"
          ),
          spO2Value4: setDefaultsValues(
            res.data,
            "oxygen",
            "Middle",
            "MaxRange"
          ),
          spO2Value5: setDefaultsValues(
            res.data,
            "oxygen",
            "Low",
            "MaxRange"
          ),
          spO2Value6: setDefaultsValues(
            res.data,
            "oxygen",
            "Low",
            "MinRange"
          ),
          fenceValue: setDefaultsValues(
            res.data,
            "fence",
            "High",
            "MinRange"
          ),
          batteryValue: setDefaultsValues(
            res.data,
            "battery",
            "High",
            "MinRange"
          )        
        });
      })
    }
    setLoading(false);
  }, [isInitialView, props.location.selected]);

  const valuetext = (value) => {
    return `${value}°C`;
  };

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const handleSliderChange = (name) => (event, newValue) => {
    setState({ ...state, [name]: newValue });
  };
  const handleClickSubmit = () => {
    setLoading(true);
    let form = [
      {
        description: "diastolic",
        isActive: state.diastolicPressure,
        ranges: [
          {
            range: "MaxRange",
            severity: "High",
            right: state.diastolicValue[1],
            left: state.diastolicValue[0],
          },
          {
            range: "MinRange",
            severity: "High",
            right: state.diastolicValue2[1],
            left: state.diastolicValue2[0],
          },
          {
            range: "MaxRange",
            severity: "Middle",
            right: state.diastolicValue3[1],
            left: state.diastolicValue3[0],
          },
          {
            range: "MinRange",
            severity: "Middle",
            right: state.diastolicValue4[1],
            left: state.diastolicValue4[0],
          },
          {
            range: "MaxRange",
            severity: "Low",
            right: state.diastolicValue5[1],
            left: state.diastolicValue5[0],
          },
          {
            range: "MinRange",
            severity: "Low",
            right: state.diastolicValue6[1],
            left: state.diastolicValue6[0],
          },
        ],
      },
      {
        description: "systolic",
        isActive: state.systolicPressure,
        ranges: [
          {
            range: "MinRange",
            severity: "High",
            right: state.systolicValue[1],
            left: state.systolicValue[0],
          },
          {
            range: "MaxRange",
            severity: "High",
            right: state.systolicValue2[1],
            left: state.systolicValue2[0],
          },
          {
            range: "MinRange",
            severity: "Middle",
            right: state.systolicValue3[1],
            left: state.systolicValue3[0],
          },
          {
            range: "MaxRange",
            severity: "Middle",
            right: state.systolicValue4[1],
            left: state.systolicValue4[0],
          },
          {
            range: "MaxRange",
            severity: "Low",
            right: state.systolicValue5[1],
            left: state.systolicValue5[0],
          },
          {
            range: "MinRange",
            severity: "Low",
            right: state.systolicValue6[1],
            left: state.systolicValue6[0],
          },
        ],
      },
      {
        description: "temperature",
        isActive: state.temperature,
        ranges: [
          {
            range: "MinRange",
            severity: "High",
            right: state.temperatureValue[1],
            left: state.temperatureValue[0],
          },
          {
            range: "MaxRange",
            severity: "High",
            right: state.temperatureValue2[1],
            left: state.temperatureValue2[0],
          },
          {
            range: "MinRange",
            severity: "Middle",
            right: state.temperatureValue3[1],
            left: state.temperatureValue3[0],
          },
          {
            range: "MaxRange",
            severity: "Middle",
            right: state.temperatureValue4[1],
            left: state.temperatureValue4[0],
          },
          {
            range: "MaxRange",
            severity: "Low",
            right: state.temperatureValue5[1],
            left: state.temperatureValue5[0],
          },
          {
            range: "MinRange",
            severity: "Low",
            right: state.temperatureValue6[1],
            left: state.temperatureValue6[0],
          },
        ],
      },
      {
        description: "oxygen",
        isActive: state.spO2,
        ranges: [
          {
            range: "MinRange",
            severity: "High",
            right: state.spO2Value[1],
            left: state.spO2Value[0],
          },
          {
            range: "MaxRange",
            severity: "High",
            right: state.spO2Value2[1],
            left: state.spO2Value2[0],
          },
          {
            range: "MinRange",
            severity: "Middle",
            right: state.spO2Value3[1],
            left: state.spO2Value3[0],
          },
          {
            range: "MaxRange",
            severity: "Middle",
            right: state.spO2Value4[1],
            left: state.spO2Value4[0],
          },
          {
            range: "MaxRange",
            severity: "Low",
            right: state.spO2Value5[1],
            left: state.spO2Value5[0],
          },
          {
            range: "MinRange",
            severity: "Low",
            right: state.spO2Value6[1],
            left: state.spO2Value6[0],
          },
        ],
      },
      {
        description: "heart_rate",
        isActive: state.heartbeat,
        ranges: [
          {
            range: "MaxRange",
            severity: "High",
            right: state.heartbeatValue[1],
            left: state.heartbeatValue[0],
          },
          {
            range: "MinRange",
            severity: "High",
            right: state.heartbeatValue2[1],
            left: state.heartbeatValue2[0],
          },
          {
            range: "MaxRange",
            severity: "Middle",
            right: state.heartbeatValue3[1],
            left: state.heartbeatValue3[0],
          },
          {
            range: "MinRange",
            severity: "Middle",
            right: state.heartbeatValue4[1],
            left: state.heartbeatValue4[0],
          },
          {
            range: "MaxRange",
            severity: "Low",
            right: state.heartbeatValue5[1],
            left: state.heartbeatValue5[0],
          },
          {
            range: "MinRange",
            severity: "Low",
            right: state.heartbeatValue6[1],
            left: state.heartbeatValue6[0]
          }
        ]
      }
    ]

    let endUser = props.location.endUserData;
    if (endUser !== undefined) {
      endUser.setDeviceValuesRanges = form;
    } else {
      endUser = null;
    }
    Swal.fire(swalSubmit).then((result) => {
      if (result.isConfirmed) {
        if (endUser !== null) {
          axiosConfig.post('/Beneficiary', endUser).then(() => {
            history.push({
              pathname: "/end-user",
            });
          }
          )
            .catch(() => {
              Swal.fire("Η καταχώρηση ήταν ανεπιτυχής");
              history.push({
                pathname: "/end-user",
              });
            });
        } else {
          axiosConfig
            .post(
              `/DeviceValues/SetDeviceValues/${props.location.selected}`,
              form
            )
            .then((res) => {
              history.push({
                pathname: "/end-user",
              });
              setLoading(false);
            });
        }
      } else {
        history.push({
          pathname: "/smart-band-values",
          selected: deviceId,
        });
        setLoading(false);
      }
    });
  };

  if (loading === false) {
    return (
      <div>
        <div className="Form">
          <Card>
            <CardHeader color="warning">
              <h1 className={classes.cardTitleWhite}>Αρχικές Ρυθμίσεις</h1>
            </CardHeader>
            <CardBody>
              <Grid container spacing={5}>
                <Grid
                  style={{ display: "flex", justifyContent: "flex-start" }}
                  item
                  sm={12}
                >
                  <div className="Logo">
                    <img src={pressureLogo} alt="diastolic" />
                  </div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.diastolicPressure}
                        onChange={handleChange}
                        name="diastolicPressure"
                        color="primary"
                        disabled={!enableEditValues || isInitialView}
                      />
                    }
                    label="Διαστολική Πίεση"
                    className={
                      (!enableEditValues || isInitialView) &&
                      classes.biometricValuesCheckboxDisabled
                    }
                    disabled={!enableEditValues || isInitialView}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.editDiastolicPressure}
                        onChange={handleChange}
                        name="editDiastolicPressure"
                        color="primary"
                      />
                    }
                    label="Επεξεργασία των Αρχικών Ρυθμίσεων της Διαστολικής Πίεσης"
                    className={
                      (!enableEditValues || isInitialView) &&
                      classes.biometricValuesCheckboxDisabled
                    }
                    disabled={!enableEditValues || isInitialView || disableDiastolicPressureByEdit}
                  />
                </Grid>
                <Grid item xs={6} style={{ paddingBottom: '30px' }}>
                  <Typography className={classes.bold}>Κατώτερα Επικίνδυνα Όρια </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography className={classes.bold}>Ανώτερα Επικίνδυνα Όρια </Typography>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12} className = {classes.gridSlider}>
                    <FormControl>
                      <MenuItem value={"high"}>Υψηλού </MenuItem>
                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>
                    <MySlider
                      min={4.5}
                      max={14}
                      step={0.1}
                      value={state.diastolicValue2}
                      onChange={
                        state.editDiastolicPressure
                          ? handleSliderChange("diastolicValue2")
                          : null
                      }
                      valueLabelDisplay="on"
                      ValueLabelComponent={StyledValueLabel}
                      aria-labelledby="range-slider"
                      getAriaValueText={valuetext}
                      marks={diastolicMarks}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <MySlider
                      min={4.5}
                      max={14}
                      step={0.1}
                      value={state.diastolicValue}
                      onChange={
                        state.editDiastolicPressure
                          ? handleSliderChange("diastolicValue")
                          : null
                      }
                      valueLabelDisplay="on"
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      aria-labelledby="range-slider"
                      marks={diastolicMarks}
                      disabled={!enableEditValues || isInitialView}
                    />
                    <FormControl>
                      <MenuItem value={"high"}>Υψηλού </MenuItem>
                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MAX</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12} className = {classes.gridSlider}>
                    <FormControl>
                      <MenuItem value={"middle"}>Μέτριου</MenuItem>
                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>
                    <MySlider
                      min={4.5}
                      max={14}
                      step={0.1}
                      value={state.diastolicValue4}
                      onChange={
                        state.editDiastolicPressure
                          ? handleSliderChange("diastolicValue4")
                          : null
                      }
                      valueLabelDisplay="on"
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      aria-labelledby="range-slider"
                      marks={diastolicMarks}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <MySlider
                      min={4.5}
                      max={14}
                      step={0.1}
                      value={state.diastolicValue3}
                      onChange={
                        state.editDiastolicPressure
                          ? handleSliderChange("diastolicValue3")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={diastolicMarks}
                      disabled={!enableEditValues || isInitialView}
                    />

                    <FormControl>
                      <MenuItem value={"middle"}>Μέτριου</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MAX</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12}  className ={classes.gridSlider}>
                    <FormControl>
                      <MenuItem value={"low"}>Χαμηλού</MenuItem>
                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>
                    <MySlider
                      min={4.5}
                      max={14}
                      step={0.1}
                      value={state.diastolicValue6}
                      onChange={
                        state.editDiastolicPressure
                          ? handleSliderChange("diastolicValue6")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={diastolicMarks}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <MySlider
                      min={4.5}
                      max={14}
                      step={0.1}
                      value={state.diastolicValue5}
                      onChange={
                        state.editDiastolicPressure
                          ? handleSliderChange("diastolicValue5")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={diastolicMarks}
                      disabled={!enableEditValues || isInitialView}
                    />
                    <FormControl>
                      <MenuItem value={"low"}>Χαμηλού</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MAX</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  style={{ display: "flex", justifyContent: "flex-start" }}
                  item
                  sm={12}
                >
                  <div className="Logo">
                    <img src={pressureLogo} alt="diastolic" />
                  </div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.systolicPressure}
                        onChange={handleChange}
                        name="systolicPressure"
                        color="primary"
                      />
                    }
                    label="Συστολική Πίεση"
                    className={
                      (!enableEditValues || isInitialView) &&
                      classes.biometricValuesCheckboxDisabled
                    }
                    disabled={!enableEditValues || isInitialView}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.editSystolicPressure}
                        onChange={handleChange}
                        name="editSystolicPressure"
                        color="primary"
                      />
                    }
                    label="Επεξεργασία των Αρχικών Ρυθμίσεων της Συστολικής Πίεσης"
                    className={
                      (!enableEditValues || isInitialView) &&
                      classes.biometricValuesCheckboxDisabled
                    }
                    disabled={!enableEditValues || isInitialView || disableSystolicPressureByEdit}
                  />
                </Grid>
                <Grid item xs={6} style={{ paddingBottom: '30px' }}>
                  <Typography className={classes.bold}>Κατώτερα Επικίνδυνα Όρια </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography className={classes.bold}>Ανώτερα Επικίνδυνα Όρια </Typography>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12} >
                    <FormControl>
                      <MenuItem value={"high"}>Υψηλού </MenuItem>
                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>
                    <MySlider
                      min={7}
                      max={22}
                      step={0.1}
                      value={state.systolicValue}
                      onChange={
                        state.editSystolicPressure
                          ? handleSliderChange("systolicValue")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={systolicMarks}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <MySlider
                      min={7}
                      max={22}
                      step={0.1}
                      value={state.systolicValue2}
                      onChange={
                        state.editSystolicPressure
                          ? handleSliderChange("systolicValue2")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={systolicMarks}
                      disabled={!enableEditValues || isInitialView}
                    />

                    <FormControl>
                      <MenuItem value={"high"}>Υψηλού</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MAX</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12}>
                    <FormControl>
                      <MenuItem value={"middle"}>Μέτριου</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>
                    <MySlider
                      min={7}
                      max={22}
                      step={0.1}
                      value={state.systolicValue3}
                      onChange={
                        state.editSystolicPressure
                          ? handleSliderChange("systolicValue3")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={systolicMarks}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <MySlider
                      min={7}
                      max={22}
                      step={0.1}
                      value={state.systolicValue4}
                      onChange={
                        state.editSystolicPressure
                          ? handleSliderChange("systolicValue4")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={systolicMarks}
                      disabled={!enableEditValues || isInitialView}
                    />

                    <FormControl>
                      <MenuItem value={"middle"}>Μέτριου</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MAX</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12} className={classes.gridSlider}>
                    <FormControl>
                      <MenuItem value={"low"}>Χαμηλού</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>
                    <MySlider
                      min={7}
                      max={22}
                      step={0.1}
                      value={state.systolicValue6}
                      onChange={
                        state.editSystolicPressure
                          ? handleSliderChange("systolicValue6")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={systolicMarks}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <MySlider
                      min={7}
                      max={22}
                      step={0.1}
                      value={state.systolicValue5}
                      onChange={
                        state.editSystolicPressure
                          ? handleSliderChange("systolicValue5")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={systolicMarks}
                      disabled={!enableEditValues || isInitialView}
                    />
                    <FormControl>
                      <MenuItem value={"low"}>Χαμηλού</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MAX</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  style={{ display: "flex", justifyContent: "flex-start" }}
                  item
                  sm={12}
                >
                  <div className="Logo">
                    <img src={temperatureLogo} alt="thermometer" />
                  </div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.temperature}
                        onChange={handleChange}
                        name="temperature"
                        color="primary"
                      />
                    }
                    label="Θερμοκρασία"
                    className={
                      (!enableEditValues || isInitialView) &&
                      classes.biometricValuesCheckboxDisabled
                    }
                    disabled={!enableEditValues || isInitialView}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.editTemperature}
                        onChange={handleChange}
                        name="editTemperature"
                        color="primary"
                      />
                    }
                    label="Επεξεργασία των Αρχικών Ρυθμίσεων της Θερμοκρασίας"
                    className={
                      (!enableEditValues || isInitialView) &&
                      classes.biometricValuesCheckboxDisabled
                    }
                    disabled={!enableEditValues || isInitialView || disableTemperatureByEdit}
                  />
                </Grid>
                <Grid item xs={6} style={{ paddingBottom: '30px' }}>
                  <Typography className={classes.bold}>Κατώτερα Επικίνδυνα Όρια </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography className={classes.bold}>Ανώτερα Επικίνδυνα Όρια </Typography>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12}>
                    <FormControl>
                      <MenuItem value={"high"}>Υψηλού</MenuItem>
                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>
                    <MySlider
                      min={25}
                      max={41}
                      step={0.1}
                      value={state.temperatureValue}
                      onChange={
                        state.editTemperature
                          ? handleSliderChange("temperatureValue")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={temperatureMarks}
                      getAriaValueText={valuetext}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <MySlider
                      min={25}
                      max={41}
                      step={0.1}
                      value={state.temperatureValue2}
                      onChange={
                        state.editTemperature
                          ? handleSliderChange("temperatureValue2")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={temperatureMarks}
                      getAriaValueText={valuetext}
                      disabled={!enableEditValues || isInitialView}
                    />
                    <FormControl>
                      <MenuItem value={"high"}>Υψηλού</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης ΜΑΧ</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12}>
                    <FormControl>
                      <MenuItem value={"middle"}>Μέτριου</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>
                    <MySlider
                      min={25}
                      max={41}
                      step={0.1}
                      value={state.temperatureValue3}
                      onChange={
                        state.editTemperature
                          ? handleSliderChange("temperatureValue3")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={temperatureMarks}
                      getAriaValueText={valuetext}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <MySlider
                      min={25}
                      max={41}
                      step={0.1}
                      value={state.temperatureValue4}
                      onChange={
                        state.editTemperature
                          ? handleSliderChange("temperatureValue4")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={temperatureMarks}
                      getAriaValueText={valuetext}
                      disabled={!enableEditValues || isInitialView}
                    />
                    <FormControl>
                      <MenuItem value={"middle"}>Μέτριου</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης ΜΑΧ</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12}>
                    <FormControl>
                      <MenuItem value={"low"}>Χαμηλού</MenuItem>
                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>
                    <MySlider
                      min={25}
                      max={41}
                      step={0.1}
                      value={state.temperatureValue6}
                      onChange={
                        state.editTemperature
                          ? handleSliderChange("temperatureValue6")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={temperatureMarks}
                      getAriaValueText={valuetext}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <MySlider
                      min={25}
                      max={41}
                      step={0.1}
                      value={state.temperatureValue5}
                      onChange={
                        state.editTemperature
                          ? handleSliderChange("temperatureValue5")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={temperatureMarks}
                      getAriaValueText={valuetext}
                      disabled={!enableEditValues || isInitialView}
                    />
                    <FormControl>
                      <MenuItem value={"low"}>Χαμηλού</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MAX</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  style={{ display: "flex", justifyContent: "flex-start" }}
                  item
                  sm={12}
                >
                  <div className="Logo">
                    <img src={heartbeatLogo} alt="heartbeat" />
                  </div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.heartbeat}
                        onChange={handleChange}
                        name="heartbeat"
                        color="primary"
                      />
                    }
                    label="Καρδιακοί Παλμοί"
                    className={
                      (!enableEditValues || isInitialView) &&
                      classes.biometricValuesCheckboxDisabled
                    }
                    disabled={!enableEditValues || isInitialView}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.editHeartbeat}
                        onChange={handleChange}
                        name="editHeartbeat"
                        color="primary"
                      />
                    }
                    label="Επεξεργασία των Αρχικών Ρυθμίσεων των Καρδιακών Παλμών"
                    className={
                      (!enableEditValues || isInitialView) &&
                      classes.biometricValuesCheckboxDisabled
                    }
                    disabled={!enableEditValues || isInitialView || disableHeartBeatByEdit}
                  />
                </Grid>
                <Grid item xs={6} style={{ paddingBottom: '30px' }}>
                  <Typography className={classes.bold}>Κατώτερα Επικίνδυνα Όρια </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography className={classes.bold}>Ανώτερα Επικίνδυνα Όρια </Typography>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12}>
                    <FormControl>
                      <MenuItem value={"high"}>Υψηλού </MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>

                    <MySlider
                      min={50}
                      max={200}
                      step={1}
                      value={state.heartbeatValue2}
                      onChange={
                        state.editHeartbeat
                          ? handleSliderChange("heartbeatValue2")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={heartbeatMarks}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <MySlider
                      min={50}
                      max={200}
                      step={1}
                      value={state.heartbeatValue}
                      onChange={
                        state.editHeartbeat
                          ? handleSliderChange("heartbeatValue")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={heartbeatMarks}
                      disabled={!enableEditValues || isInitialView}
                    />
                    <FormControl>
                      <MenuItem value={"high"}>Υψηλού </MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MAX</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12}>
                    <FormControl>
                      <MenuItem value={"middle"}>Μέτριου</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>

                    <MySlider
                      min={50}
                      max={200}
                      step={1}
                      value={state.heartbeatValue4}
                      onChange={
                        state.editHeartbeat
                          ? handleSliderChange("heartbeatValue4")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={heartbeatMarks}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <MySlider
                      min={50}
                      max={200}
                      step={1}
                      value={state.heartbeatValue3}
                      onChange={
                        state.editHeartbeat
                          ? handleSliderChange("heartbeatValue3")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={heartbeatMarks}
                      disabled={!enableEditValues || isInitialView}
                    />

                    <FormControl>
                      <MenuItem value={"middle"}>Μέτριου</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MAX</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12}>
                    <FormControl>
                      <MenuItem value={"low"}>Χαμηλού</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>
                    <MySlider
                      min={50}
                      max={200}
                      step={1}
                      value={state.heartbeatValue6}
                      onChange={
                        state.editHeartbeat
                          ? handleSliderChange("heartbeatValue6")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={heartbeatMarks}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                  <Grid item sm={12}>
                    <MySlider
                      min={50}
                      max={200}
                      step={1}
                      value={state.heartbeatValue5}
                      onChange={
                        state.editHeartbeat
                          ? handleSliderChange("heartbeatValue5")
                          : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={heartbeatMarks}
                      disabled={!enableEditValues || isInitialView}
                    />

                    <FormControl>
                      <MenuItem value={"low"}>Χαμηλού</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MAX</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  style={{ display: "flex", justifyContent: "flex-start" }}
                  item
                  smm={12}
                >
                  <div className="Logo">
                    <img src={spo2Logo} alt="spO2" />
                  </div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.spO2}
                        onChange={handleChange}
                        name="spO2"
                        color="primary"
                      />
                    }
                    label="SpO2"
                    className={
                      (!enableEditValues || isInitialView) &&
                      classes.biometricValuesCheckboxDisabled
                    }
                    disabled={!enableEditValues || isInitialView}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.editSpO2}
                        onChange={handleChange}
                        name="editSpO2"
                        color="primary"
                      />
                    }
                    label="Επεξεργασία των Αρχικών Ρυθμίσεων SpO2"
                    className={
                      (!enableEditValues || isInitialView) &&
                      classes.biometricValuesCheckboxDisabled
                    }
                    disabled={!enableEditValues || isInitialView || disableSpo2ByEdit}
                  />
                </Grid>
                <Grid item xs={12} style={{ paddingBottom: '30px' }}>
                  <Typography className={classes.bold}>Κατώτερα Επικίνδυνα Όρια </Typography>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12}>
                    <FormControl>
                      <MenuItem value={"high"}>Υψηλού </MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>

                    <MySlider
                      min={89}
                      max={100}
                      step={0.1}
                      value={state.spO2Value}
                      onChange={
                        state.editSpO2 ? handleSliderChange("spO2Value") : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={spO2Marks}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12}>
                    <FormControl>
                      <MenuItem value={"middle"}>Μέτριου</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>

                    <MySlider
                      min={89}
                      max={100}
                      step={0.1}
                      value={state.spO2Value3}
                      onChange={
                        state.editSpO2 ? handleSliderChange("spO2Value3") : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={spO2Marks}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={12}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sm={12}>
                    <FormControl>
                      <MenuItem value={"low"}>Χαμηλού</MenuItem>

                      <FormHelperText className = {classes.FormHelperText}>Δείκτης MIN</FormHelperText>
                    </FormControl>

                    <MySlider
                      min={89}
                      max={100}
                      step={0.1}
                      value={state.spO2Value6}
                      onChange={
                        state.editSpO2 ? handleSliderChange("spO2Value6") : null
                      }
                      ValueLabelComponent={StyledValueLabel}
                      getAriaValueText={valuetext}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      marks={spO2Marks}
                      disabled={!enableEditValues || isInitialView}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                sm={12}
                style={{ display: "flex", justifyContent: "flex-start" }}
              ></Grid>
              <Grid container>
                <Grid
                  item
                  sm={6}
                  style={{ textAlign: "center", marginTop: "16px" }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={isInitialView}
                    className={isInitialView && classes.disabledButtons}
                    onClick={() => {
                      setEnableEditValues(true);
                    }}
                  >
                    Αλλαγη Ρυθμισεων
                  </Button>
                </Grid>
                <Grid
                  item
                  sm={6}
                  style={{ textAlign: "center", marginTop: "16px" }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={isInitialView}
                    className={isInitialView && classes.disabledButtons}
                    onClick={() => {
                      handleClickSubmit();
                    }}
                  >
                    Επιβεβαιωση
                  </Button>
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        </div>
      </div>
    );
  } else {
    return <Loading></Loading>;
  }
}